import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useOverview } from "@/lib/useOverview";
import { relativeTime } from "@/lib/format";
import BrandLogo from "@/components/BrandLogo";
import DateRange from "@/components/DateRange";
import SyncStatusStrip from "@/components/SyncStatusStrip";
import Kpis from "@/components/dashboard/Kpis";
import Glance from "@/components/dashboard/Glance";
import WhatsWorking from "@/components/dashboard/WhatsWorking";
import SocialPerformance from "@/components/dashboard/SocialPerformance";
import Trends from "@/components/dashboard/Trends";
import { Loader2 } from "lucide-react";

export default function Home() {
  const { org } = useAuth();
  const [range, setRange] = useState(30);
  const { data, isLoading } = useOverview(range);

  if (isLoading || !data) {
    return <div className="grid h-[60vh] place-items-center"><Loader2 className="h-8 w-8 animate-spin text-brand-primary" /></div>;
  }

  return (
    <div className="space-y-10">
      <header className="space-y-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <BrandLogo org={org} size={56} className="shadow-sm" />
            <div>
              <p className="text-sm font-medium text-muted-foreground">{org?.name}</p>
              <h1 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Marketing Overview</h1>
            </div>
          </div>
          <DateRange value={range} onChange={setRange} />
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-muted-foreground">How your marketing is performing across channels.</p>
          <span className="text-xs text-muted-foreground">Updated {relativeTime(data.freshness.last_updated)}</span>
        </div>
        <SyncStatusStrip freshness={data.freshness} />
        <Kpis headline={data.headline} />
      </header>

      <Glance glance={data.glance} />
      <WhatsWorking posts={data.whats_working} />
      <SocialPerformance social={data.social} />
      <Trends trends={data.trends} />
    </div>
  );
}
